import type { MutableRefObject } from 'react';
import type { LiveVoiceSession } from '@/lib/live-voice-session';

type ResettableControllers = {
  ui: {
    callConnectedAtRef: MutableRefObject<number | null>;
    micUnmutedAtRef: MutableRefObject<number | null>;
    setCallElapsedMs: (elapsedMs: number) => void;
    setStatus: (status: 'idle') => void;
    setIsCapturing: (capturing: boolean) => void;
    setPttActive: (active: boolean) => void;
  };
  responses: { reset: () => void };
  questionnaire: { reset: () => void };
  receipts: { clearReceipts: () => void };
};

/** Release a call's session, lease and UI state once its token is retired. */
export function resetRealtimeVoiceCall(args: {
  controllers: ResettableControllers;
  sessionRef: MutableRefObject<LiveVoiceSession | null>;
  callOpenedAtRef: MutableRefObject<number | null>;
  endActiveLease: () => void;
}) {
  const { controllers } = args;
  args.callOpenedAtRef.current = null;
  controllers.ui.callConnectedAtRef.current = null;
  controllers.ui.setCallElapsedMs(0);
  controllers.ui.micUnmutedAtRef.current = null;
  controllers.responses.reset();
  controllers.questionnaire.reset();
  controllers.receipts.clearReceipts();
  args.sessionRef.current?.close();
  args.sessionRef.current = null;
  args.endActiveLease();
  controllers.ui.setStatus('idle');
  controllers.ui.setIsCapturing(false);
  controllers.ui.setPttActive(false);
}
